import React, { Component } from 'react';
import { Button, Modal, Col, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { connect } from 'react-redux';
import { modalPropsUpdate, modalStatus, scorecardModals } from './helper';
import {
    setScorecardId
} from '../../../Admin/Scorecard/Create/action';
import './style.css';
import AuthService from '../../Services/AuthService';
class ModalComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            authModal: false,
            saveSuccess: false,
            actionType: '',
            type: '',
            id: null,
            validationMessage: ''
        }
        this.Auth = new AuthService();
    }
    componentDidUpdate(prevProps) {
        const { detailsError, searchFailure, scorecardCreateSuccess, scorecardCreateError, sectionTemplateSuccess, sectionTemplateError } = this.props
        const updateFlag = modalPropsUpdate(detailsError, prevProps, scorecardCreateSuccess, scorecardCreateError, sectionTemplateSuccess, sectionTemplateError);
        const checkstatus = modalStatus(detailsError, scorecardCreateError, searchFailure, sectionTemplateError);
        if (updateFlag) {
            if (checkstatus) {
                this.toggle()
            }
            if (scorecardCreateSuccess) {
                this.scorecardModals();
            } /* else if (sectionTemplateSuccess) {
                this.sectionTemplateModals();
            } */
            if (scorecardCreateError) {
                if (scorecardCreateError.data.status === 400) {
                    this.setState({
                        validateScorecard: !this.state.validateScorecard,
                        validationMessage: this.props.scorecardCreateError.data.data
                    })
                }
            } /* else if (sectionTemplateError) {
                if (sectionTemplateError.data.response) {
                    if (sectionTemplateError.data.response.status === 400) {
                        this.setState({
                            validateScorecard: !this.state.validateScorecard,
                            validationMessage: sectionTemplateError.data.response.data.message
                        })
                    } else if (sectionTemplateError.data.response.status === 500) {
                        this.setState({
                            validateScorecard: !this.state.validateScorecard,
                            validationMessage: sectionTemplateError.data.response.data.message /* 'File Uplaoded Do not Match The Table Data Type Selected' */
                        /*})
                    }
                } else {
                    this.setState({
                        validateScorecard: !this.state.validateScorecard,
                        validationMessage: 'Error Creating Section Template'
                    })
                }
            } */
        }
    }
    /* sectionTemplateModals = () => {
        this.setState({ type: 'Section Template' })
        const sectionTemplateModals = sectionTemplateModal(this.props, this.state)
        if (sectionTemplateModals.sectionTemplateAction === 'Created') {
            this.setState({
                saveSuccess: !this.state.saveSuccess,
                actionType: 'Created',
                id: this.props.sectionTemplateSuccess.data.id
            });
        } else {
            this.setState({
                saveSuccess: !this.state.saveSuccess,
                actionType: 'Edited',
                id: this.props.match.params.sectionTemplateId
            });
        }
    } */
    scorecardModals = () => {
        this.setState({ type: 'Scorecard' });
        const scoreModalData = scorecardModals(this.props, this.state)
        if (scoreModalData.scorecardAction === 'Created') {
            // this.props.setScorecardId(this.props.scorecardCreateSuccess.data.data.id);
            this.setState({
                saveSuccess: !this.state.saveSuccess,
                actionType: 'Created',
                id: this.props.scorecardCreateSuccess.data.data.id
            })
        } else {
            this.setState({
                saveSuccess: !this.state.saveSuccess,
                actionType: 'Edited',
                id: this.props.match.params.scorecardid
            })
        }
    }
    toggle = () => {
        this.setState({
            authModal: !this.state.authModal
        })
    }
    handleClose = () => {
        if (this.state.type === 'Section Template') {
            this.setState({
                saveSuccess: !this.state.saveSuccess
            }, () => {
                this.props.history.push('../search');
            })
        } else if (this.state.type === 'Scorecard') {
            this.setState({
                saveSuccess: !this.state.saveSuccess
            }, () => {
                this.props.history.push('../search');
            })
        }

    }
    redirectToView = () => {
        this.props.history.push('/sectiontemplate/view/' + this.state.id);
    }
    handleLogout = () => {
        this.Auth.logout();
        this.props.push('/login');
    }
    close = () => {
        this.setState({
            validateScorecard: !this.state.validateScorecard
        });
    }
    render() {
        return (<div>
            <Modal isOpen={this.state.authModal} className="popup-design">
                <div className="modal-dialog modal-frame modal-bottom popup-design modal-dialog-scrollable" role="document">
                    <div className="modal-content pop-up">
                        <div className="modal-body">
                            <div className="row d-flex justify-content-center align-items-center">
                                <div className="popup-content">
                                    <p className="pt-3 pr-2"><i className="fa fa-exclamation-triangle red"></i>&nbsp;&nbsp;Authorization Error 401. Click Logout to Proceed</p>
                                </div>
                                <div className="row popup-buttons">
                                    <Col md="12" sm="12" lg="12" xs="12" >
                                        <Button className="btn btn-secondary close-button" color="info" onClick={this.handleLogout}>Logout</Button>{' '}
                                    </Col>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            {/* <Modal isOpen={this.state.saveSuccess} toggle={this.handleClose} className={this.props.className}>
                <ModalHeader toggle={this.toggle}>Success</ModalHeader>
                <ModalBody>
                    <p className="pt-3 pr-2"><i className="fa fa-check green"></i>&nbsp;&nbsp;{this.state.type} {this.state.actionType} successfully.</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={this.handleClose}>Close</Button>
                    <Button className="btn btn-primary" color="primary" onClick={this.redirectToView}>View Changes</Button>
                </ModalFooter>
            </Modal> */}
            {/* <Modal isOpen={this.state.saveSuccess} className="popup-design">
                <div className="modal-dialog modal-frame modal-bottom popup-design" role="document">
                    <div className="modal-content pop-up">
                        <div className="modal-body">
                            <div className="row d-flex justify-content-center align-items-center">
                                <div className="popup-content">
                                    <p className="pt-3 pr-2"><i className="fa fa-check green"></i>&nbsp;&nbsp;{this.state.type} {this.state.actionType} successfully.</p>
                                </div>
                                <div className="row popup-buttons">
                                    <Col md="6" sm="6" lg="6" xs="6" >
                                        <Button className="btn btn-secondary close-button" color="secondary" onClick={this.handleClose}>Close</Button>
                                    </Col>
                                    <Col md="6" sm="6" lg="6" xs="6" >
                                        <Button className="btn btn-primary view-button" color="primary" onClick={this.redirectToView}>View Changes</Button>
                                    </Col>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal> */}
            <div>
                <Modal isOpen={this.state.validateScorecard} toggle={this.close} className={this.props.className}>
                    <ModalHeader toggle={this.toggle}>Error</ModalHeader>
                    <ModalBody>
                        <p><i className="fa fa-exclamation-circle red"></i>&nbsp;&nbsp;{this.state.validationMessage}</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.close}>Close</Button>
                    </ModalFooter>
                </Modal>
            </div>
            {/* <Modal isOpen={this.state.validateScorecard} className="popup-design">
                <div className="modal-dialog modal-frame modal-bottom popup-design" role="document">
                    <div className="modal-content pop-up">
                        <div className="modal-body">
                            <div className="row d-flex justify-content-center align-items-center">
                                <div className="popup-content">
                                    <p className="pt-3 pr-2"><i className="fa fa-exclamation-circle red"></i>&nbsp;&nbsp;{this.state.validationMessage}</p>
                                </div>
                                <div className="row popup-buttons">
                                    <Col md="12" sm="12" lg="12" xs="12" >
                                        <Button className="btn btn-secondary close-button" color="primary" onClick={this.close}>Close</Button>
                                    </Col>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal> */}
        </div >)
    }
}
const mapStateToProps = (state, ownProps) => ({
    scorecardId: state.createScorecard.id,
    detailsError: state.createScorecard.detailsError,
    scorecardCreateSuccess: state.createScorecard.createScorecardSuccess,
    scorecardCreateError: state.createScorecard.createScorecardError,
    searchFailure: state.createScorecard.scorecardCreateError,
    sectionTemplateSuccess: state.sectionTemplate.sectionTemplateSuccess,
    sectionTemplateError: state.sectionTemplate.sectionTemplateError
})
const mapDispatchToProps = (dispatch, ownProps) => ({
    setScorecardId: (id) => dispatch(setScorecardId(id))
})
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ModalComponent);